import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
	barraAzul: {
		backgroundImage: 'linear-gradient(278deg, #061f80, #0430ad)',
		width: '100%',
		height: 160,
		position: 'absolute',
	},
	jumbotron: {
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		position: 'relative',
	},
	botaoDesativar: {
		borderRadius: 6,
		border: 'solid 1px #97c1ff',
		backgroundColor: '#fff',
		boxShadow: 'none',
		textTransform: 'none',
		color: '#044ada',
		'&:hover': {
			boxShadow: 'none',
			backgroundColor: '#fafafa',
		},
	},
})

export default useStyles;